const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyA1LjQxNDIxVjIySDExVjUuNDE0MjFMNC43MDcxMSAxMS43MDcxTDMuMjkyODkgMTAuMjkyOUwxMiAxLjU4NTc4TDIwLjcwNzEgMTAuMjkyOUwxOS4yOTI5IDExLjcwNzFMMTMgNS40MTQyMVoiLz4KPC9zdmc+Cg==";
export {
  M as default
};
//# sourceMappingURL=up-05342ed7.mjs.map
